<template>
  <a-row type="flex" justify="center" style="height: 5vh">
    <a-col :span="7" class="team_index_bar_item">
      <router-link to="/team/partner">
        <div class="bar_item item_focus" tabindex="1" id="partner">投资合伙人</div>
      </router-link>
    </a-col>
    <a-col :span="6" class="team_index_bar_item">
      <router-link to="/team/manager_adviser">
        <div class="bar_item" tabindex="2" id="manager&adviser">投资经理及顾问</div>
      </router-link>
    </a-col>
    <a-col :span="7" class="team_index_bar_item">
      <router-link to="/team/post_investment_operation">
        <div class="bar_item" tabindex="3" id="post_investment&legal&operation">投后及运营团队</div>
      </router-link>
    </a-col>
  </a-row>
</template>

<script>
import {onBeforeRouteUpdate, } from "vue-router"
import {onMounted} from 'vue'

export default {
  name: 'Team_index_bar',
  setup() {
    onBeforeRouteUpdate((from, to) => {
      let from_id = ''
      let to_id = ''
      if (from.name.search("partner") >= 0) {
        from_id = "partner"
      } else if ((from.name.search("manager") >= 0) || (from.name.search("adviser") >= 0)) {
        from_id = "manager&adviser"
      }
      else if ((from.name.search("post_investment") >= 0) || (from.name.search("legal") >= 0) || (from.name.search("operation") >= 0)){
        from_id = "post_investment&legal&operation"
      }
      if (to.name.search("partner") >= 0) {
        to_id = "partner"
      } else if ((to.name.search("manager") >= 0) || (to.name.search("adviser") >= 0)) {
        to_id = "manager&adviser"
      }
      else if ((to.name.search("post_investment") >= 0) || (to.name.search("legal") >= 0) || (to.name.search("operation") >= 0)){
        to_id = "post_investment&legal&operation"
      }
      //from 是下一个目标地址 to是上一个来源的地址
      document.getElementById(to_id).classList.remove("item_focus")
      document.getElementById(from_id).classList.add("item_focus")
    })

    onMounted(() => {
      console.log(window.location.href)
      if (document.getElementById("partner").classList.value.search("item_focus") >= 0){
        document.getElementById("partner").classList.remove("item_focus")
      }
      if (document.getElementById("manager&adviser").classList.value.search("item_focus") >= 0){
        document.getElementById("manager&adviser").classList.remove("item_focus")
      }
      if (document.getElementById("post_investment&legal&operation").classList.value.search("item_focus") >= 0){
        document.getElementById("post_investment&legal&operation").classList.remove("item_focus")
      }

      if(window.location.href.search('partner') >= 0){
        document.getElementById('partner').classList.add("item_focus")
      }
      else if(window.location.href.search('manager_adviser') >= 0){
        document.getElementById('manager&adviser').classList.add("item_focus")
      }
      else if(window.location.href.search('post_investment_operation') >= 0){
        document.getElementById('post_investment&legal&operation').classList.add("item_focus")
      }
    })
  }
}
</script>

<style scoped>
.team_index_bar_item {
  background: grey;
  margin: 0 0.1vh;
  line-height: 5vh;
}

.bar_item {
  color: white;
}

.item_focus {
  background-color: #2f54eb;
}

</style>